import { useCallback, useMemo } from "react";
import { AlertProps } from "@/base/components/index";
import {
  QueueMessagesQueueValueType,
  QueueMessagesQueueLevelType,
  useContextQueueMessage,
} from "@/app/module/index";

export function useNotifications(
  level: QueueMessagesQueueLevelType = "global",
) {
  const { addMessage, removeMessage, messageItems } = useContextQueueMessage();

  const currentMessage = useMemo(() => {
    return messageItems.filter((message) => message.level === level).shift();
  }, [messageItems, level]);

  const memoizedAddMessage = useCallback(
    (value: QueueMessagesQueueValueType<AlertProps>) =>
      addMessage(value, level),
    [addMessage, level],
  );

  const memoizedRemoveCurrentMessage = useCallback(
    () => removeMessage(currentMessage?.id),
    [currentMessage, removeMessage],
  );

  return useMemo(
    () => ({
      currentMessage,
      show: memoizedAddMessage,
      remove: removeMessage,
      removeCurrentMessage: memoizedRemoveCurrentMessage,
    }),
    [
      memoizedAddMessage,
      removeMessage,
      currentMessage,
      memoizedRemoveCurrentMessage,
    ],
  );
}
